import "Layouts/default";

import 'Ui/slider';
import 'Ui/tabs';

import 'Common/social';
import 'Common/lightgallery';
import { buildStars, buildArticleStars } from 'Functions/rating';
import { updateLazy } from "Functions/lazy";
import { scrollToEl } from "Functions/anchor";

buildStars()
buildArticleStars()
updateLazy()

document.querySelector('.c-article').querySelectorAll('[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
        event.preventDefault()
        scrollToEl(document.querySelector(event.currentTarget.getAttribute('href')), 30)
    })
})

setTimeout(function() {
    if (location.hash) {
        window.scrollTo(0, 0);
        scrollToEl(document.querySelector(location.hash), 30)
    }
}, 1);
